/**
 * PDP Size Selector
 * - Keeps product title (h1) and browser tab title free of selected size
 * - Updates in-stock label beside the size header when variant changes
 * - Marks sizes unavailable for the selected color
 */
(function () {
  'use strict';

  var originalDocumentTitle = null;

  function lockProductTitles() {
    document.querySelectorAll('[data-product-title-lock]').forEach(function (el) {
      var locked = el.getAttribute('data-product-title-lock');
      if (!locked) {
        return;
      }

      var link = el.querySelector('a');

      if (link) {
        if (link.textContent.trim() !== locked) {
          link.textContent = locked;
        }
        return;
      }

      if (el.textContent.trim() !== locked) {
        el.textContent = locked;
      }
    });
  }

  function lockDocumentTitle() {
    if (originalDocumentTitle === null) {
      originalDocumentTitle = document.title;
      return;
    }

    if (document.title !== originalDocumentTitle) {
      document.title = originalDocumentTitle;
    }
  }

  function getActiveColor() {
    var active = document.querySelector('.pcs-swatches .pcs-swatch--active');
    return active ? active.dataset.color : '';
  }

  function getVariantData() {
    var node = document.querySelector('[id^="pcs-variant-data-"]');
    if (!node) return [];
    try {
      return JSON.parse(node.textContent);
    } catch (err) {
      return [];
    }
  }

  function getColorOptionIndex() {
    var wrapper = document.querySelector('.pcs-swatches');
    if (!wrapper) return -1;
    var parsed = parseInt(wrapper.dataset.colorOptionIndex || '-1', 10);
    return Number.isNaN(parsed) ? -1 : parsed;
  }

  function getSizeIndex() {
    var sizeRadio = document.querySelector('.product-form__size-selector input[type="radio"]');
    if (!sizeRadio || !sizeRadio.name) return -1;
    return parseInt(String(sizeRadio.name).replace('option', ''), 10) - 1;
  }

  function hasNativeColorVariantData() {
    // Linked-colour PDPs (one product per colour) have no pcs-variant-data.
    // Empty data must NOT mark every size unavailable.
    return getVariantData().length > 0 && getColorOptionIndex() >= 0;
  }

  function normalizeOptionValue(value) {
    return String(value || '').trim().toLowerCase();
  }

  function isSizeAvailable(sizeValue, colorName) {
    var variants = getVariantData();
    if (!variants.length) return true;
    var colorIndex = getColorOptionIndex();
    var sizeIndex = getSizeIndex();
    var sizeNorm = normalizeOptionValue(sizeValue);
    var colorNorm = normalizeOptionValue(colorName);
    return variants.some(function (entry) {
      if (!entry.available || !entry.options) return false;
      if (colorIndex >= 0 && colorNorm) {
        if (normalizeOptionValue(entry.options[colorIndex]) !== colorNorm) return false;
      }
      if (sizeIndex >= 0 && normalizeOptionValue(entry.options[sizeIndex]) !== sizeNorm) return false;
      return true;
    });
  }

  function resolveStockVariant(eventVariant) {
    var colorName = getActiveColor();
    var colorIndex = getColorOptionIndex();
    var variants = getVariantData();
    var sizeRadio = document.querySelector('.product-form__size-selector input[type="radio"]:checked');
    var sizeIndex = getSizeIndex();

    if (variants.length && colorName && sizeRadio) {
      var matched = variants.find(function (entry) {
        if (!entry.options) return false;
        if (colorIndex >= 0 && entry.options[colorIndex] !== colorName) return false;
        if (sizeIndex >= 0 && entry.options[sizeIndex] !== sizeRadio.value) return false;
        return true;
      });
      if (matched) return matched;
    }

    return eventVariant || null;
  }

  function updateSizeStock(variant) {
    var stockVariant = resolveStockVariant(variant);
    document.querySelectorAll('[data-size-stock]').forEach(function (stockEl) {
      var inStock = stockEl.querySelector('.product-form__size-stock-text--in');
      var outStock = stockEl.querySelector('.product-form__size-stock-text--out');

      if (!stockVariant) {
        return;
      }

      var available = stockVariant.available !== false;
      if (inStock) inStock.hidden = !available;
      if (outStock) outStock.hidden = available;
    });
  }

  function isColorAvailable(colorName) {
    var variants = getVariantData();
    if (!variants.length) return true;
    var colorIndex = getColorOptionIndex();
    var colorNorm = normalizeOptionValue(colorName);
    return variants.some(function (entry) {
      if (!entry.available || !entry.options) return false;
      if (colorIndex >= 0 && colorNorm) {
        return normalizeOptionValue(entry.options[colorIndex]) === colorNorm;
      }
      return true;
    });
  }

  function updateColorAvailability() {
    // Linked colour swatches navigate to sibling products — do not disable them here.
    if (document.querySelector('.pcs-wrapper--linked') || !hasNativeColorVariantData()) {
      return;
    }
    document.querySelectorAll('.pcs-wrapper--native .pcs-swatches .pcs-swatch').forEach(function (swatch) {
      var available = isColorAvailable(swatch.dataset.color);
      swatch.classList.toggle('is-unavailable', !available);
      swatch.classList.toggle('is-disabled', !available);
      if (available) {
        swatch.removeAttribute('aria-disabled');
      } else {
        swatch.setAttribute('aria-disabled', 'true');
      }
    });
  }

  function updateSizeAvailability() {
    // Without native Colour×Size variant JSON, leave availability to theme ProductVariants.
    if (!hasNativeColorVariantData()) {
      return;
    }

    var colorName = getActiveColor();
    var firstAvailableRadio = null;
    var selectedUnavailable = false;

    document.querySelectorAll('.product-form__size-pill').forEach(function (pill) {
      var radio = pill.querySelector('input[type="radio"]');
      if (!radio) return;
      var available = isSizeAvailable(radio.value, colorName);
      pill.classList.toggle('is-unavailable', !available);
      pill.classList.toggle('is-disabled', !available);
      pill.removeAttribute('hidden');
      if (available && !firstAvailableRadio) {
        firstAvailableRadio = radio;
      }
      if (!available && radio.checked) {
        selectedUnavailable = true;
      }
    });

    if (selectedUnavailable && firstAvailableRadio) {
      document.querySelectorAll('.product-form__size-selector input[type="radio"]').forEach(function (radio) {
        var isMatch = radio === firstAvailableRadio || radio.value === firstAvailableRadio.value;
        radio.checked = isMatch;
        if (isMatch) {
          radio.setAttribute('checked', 'checked');
          var bindId = radio.getAttribute('data-bind-value');
          var label = bindId ? document.getElementById(bindId) : null;
          if (label) label.textContent = radio.value;
        } else {
          radio.removeAttribute('checked');
        }
      });
      firstAvailableRadio.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function highlightActiveColor(colorName) {
    if (!colorName) return;
    document.querySelectorAll('.pcs-swatches').forEach(function (wrapper) {
      wrapper.querySelectorAll('.pcs-swatch').forEach(function (swatch) {
        var isActive = swatch.dataset.color === colorName;
        swatch.classList.toggle('pcs-swatch--active', isActive);
        swatch.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });
      var nameEl = document.getElementById('pcs-active-name-' + wrapper.id.replace('pcs-swatches-', ''));
      if (nameEl) nameEl.textContent = colorName;
    });
  }

  function initTitleLock() {
    lockProductTitles();
    originalDocumentTitle = document.title;

    document.querySelectorAll('[data-product-title-lock]').forEach(function (el) {
      var observer = new MutationObserver(function () {
        lockProductTitles();
      });

      observer.observe(el, {
        childList: true,
        characterData: true,
        subtree: true
      });
    });

    updateSizeAvailability();
    updateColorAvailability();
    highlightActiveColor(getActiveColor());
  }

  document.addEventListener('variant:changed', function (event) {
    lockProductTitles();
    lockDocumentTitle();
    updateSizeStock(event.detail && event.detail.variant);
    updateSizeAvailability();
    updateColorAvailability();
    var variant = event.detail && event.detail.variant;
    var colorIndex = getColorOptionIndex();
    if (variant && variant.options && colorIndex >= 0) {
      highlightActiveColor(getActiveColor() || variant.options[colorIndex]);
    }
  });

  document.addEventListener('change', function (event) {
    if (!event.target || !event.target.closest('.product-form__size-selector')) {
      return;
    }
    updateSizeStock(null);
    updateSizeAvailability();
    updateColorAvailability();
  });

  document.addEventListener('click', function (event) {
    var unavailableColor = event.target.closest('.pcs-swatch.is-unavailable, .pcs-swatch.is-disabled');
    if (unavailableColor) {
      event.preventDefault();
      event.stopPropagation();
      return;
    }
    var pill = event.target.closest('.product-form__size-pill');
    if (!pill || !pill.classList.contains('is-unavailable')) {
      return;
    }
    event.preventDefault();
    event.stopPropagation();
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTitleLock);
  } else {
    initTitleLock();
  }
})();
